'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _textField = require('material-ui/lib/text-field');

var _textField2 = _interopRequireDefault(_textField);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactTinymce = require('react-tinymce');

var _reactTinymce2 = _interopRequireDefault(_reactTinymce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BinaryTextBox = function (_Component) {
  _inherits(BinaryTextBox, _Component);

  function BinaryTextBox(props) {
    _classCallCheck(this, BinaryTextBox);

    var _this = _possibleConstructorReturn(this, (BinaryTextBox.__proto__ || Object.getPrototypeOf(BinaryTextBox)).call(this, props));

    _this.state = {
      errorText: '',
      default_value: '',
      autocomplete_items: []
    };
    _this.styles = require('./BinaryTextBox.scss');
    if (!_this.props.disabled && (!_this.props.defaultValue || _this.props.defaultValue === '')) {
      if (!(_this.props.value && _this.props.value.trim().length > 0)) {
        _this.state.errorText = _this.props.name ? 'Please enter a value for ' + _this.props.name : 'This field is required';
      }
    }
    if (_this.props.defaultValue && _this.state.errorText === '') {
      _this.state.errorText = _this.getErrors(_this.props.defaultValue);
    }
    return _this;
  }

  _createClass(BinaryTextBox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var defaultValue = this.props.defaultValue;

      if (defaultValue) {
        this.onChange({ target: { value: defaultValue } });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(event) {
      var _this2 = this;

      var _props = this.props,
          autocomplete = _props.autocomplete,
          onChange = _props.onChange;

      var value = event.target.value.replace(/\n/g, ' ');
      var autocompleteItems = autocomplete ? this.getAutoComplete(value) : [];
      var errors = this.getErrors(value);

      this.setState({
        autocomplete_items: autocompleteItems.slice(0, 10),
        default_value: value,
        errorText: errors.length > 0 ? errors[0] : ''
      }, function () {
        if (onChange) {
          onChange(_this2.replaceAutoComplete(value));
        }
      });
    }
  }, {
    key: 'getErrors',
    value: function getErrors(value) {
      var _props2 = this.props,
          name = _props2.name,
          validatePhone = _props2.validatePhone,
          validateNumeric = _props2.validateNumeric,
          validateAtLeastOneAlphabet = _props2.validateAtLeastOneAlphabet,
          validateEmail = _props2.validateEmail,
          validateUserName = _props2.validateUserName,
          validatePassword = _props2.validatePassword;

      var errors = [];
      var emptyError = this.getEmptyError(value, name);
      if (emptyError.length > 0) {
        errors.push(emptyError);
      }
      if (this.checkEmpty(value)) {
        errors.push('Please enter a value for ' + name);
      }
      if (!this.checkLimit(value)) {
        errors.push('Maximum of ' + this.props.limit + ' characters');
      }
      var minCharsError = this.getMinCharsError(value);
      if (minCharsError.length > 0) {
        errors.push(minCharsError);
      }
      if (validateNumeric && this.checkNumeric(value)) {
        errors.push(name + ' cannot contain only numbers');
      }
      if (validateEmail && !this.checEmail(value)) {
        errors.push('Invalid email address');
      }
      if (validatePhone && !this.checkPhone(value)) {
        errors.push('Invalid phone number');
      }
      if (validateUserName && !this.checkUserName(value)) {
        errors.push(name + ' must contain only alphabet and number');
      }
      if (validatePassword && !this.checkPassword(value)) {
        errors.push('Password must contain at least one uppercase alphabet, one lowercase alphabet and one numeric.');
      }
      if (validateAtLeastOneAlphabet && !this.checkAtLeastOneAlphabet(value)) {
        errors.push(name + ' must contain at least one alphabet character.');
      }
      return errors;
    }
  }, {
    key: 'getEmptyError',
    value: function getEmptyError(value, name) {
      var emptyLabel = this.props.emptyLabel;

      var error = '';
      if (this.checkEmpty(value)) {
        if (emptyLabel) {
          error = emptyLabel;
        } else {
          error = 'Please enter a value for ' + name;
        }
      }
      return error;
    }
  }, {
    key: 'getMinCharsError',
    value: function getMinCharsError(value) {
      var minCharsLabel = this.props.minCharsLabel;

      var error = '';
      if (!this.checkMinChars(value)) {
        if (minCharsLabel) {
          error = minCharsLabel;
        } else {
          error = 'Required at least ' + (parseInt(this.props.minChars, 10) + 1) + ' characters';
        }
      }
      return error;
    }
  }, {
    key: 'getAutoComplete',
    value: function getAutoComplete(value) {
      var autocomplete = this.props.autocomplete;

      var autocompleteItems = [];
      if (value.indexOf('@') !== -1) {
        var valueToFind = value.toLowerCase().slice(value.indexOf('@'), value.length);
        if (valueToFind !== '@') {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = autocomplete[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;

              if (item.name.toLowerCase().indexOf(valueToFind.replace('@', '')) === 0) {
                var autocompleteItem = item.name + ' - ' + item.id;
                var autocompleteItemHighLight = autocompleteItem.toLowerCase().replace(valueToFind.replace('@', ''), '<strong>' + valueToFind.replace('@', '') + '</strong>');
                autocompleteItems.push(_react2.default.createElement('span', { onClick: this.handleAutoCompleteClick.bind(this, item), className: this.styles.autocomplete_item, key: item.id, dangerouslySetInnerHTML: { __html: autocompleteItemHighLight } }));
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
      }
      return autocompleteItems;
    }
  }, {
    key: 'handleRTEChange',
    value: function handleRTEChange(editor) {
      var onChange = this.props.onChange;

      onChange(editor.target.getContent());
    }
  }, {
    key: 'handleRTEKeypress',
    value: function handleRTEKeypress(event, editor) {
      var customevent = void 0; // The custom event that will be created
      if (event.charCode === 94) {
        event.preventDefault();
      }
      if (document.createEvent) {
        customevent = document.createEvent('HTMLEvents');
        customevent.initEvent('keypress', true, true);
      } else {
        customevent = document.createEventObject();
        customevent.eventType = 'keypress';
      }
      customevent.eventName = 'keypress';
      customevent.charCode = event.charCode;
      customevent.customTarget = event.target;
      customevent.editor = editor;
      if (document.createEvent) {
        document.dispatchEvent(customevent);
      } else {
        document.fireEvent('on' + customevent.eventType, customevent);
      }
    }
  }, {
    key: 'handleAutoCompleteClick',
    value: function handleAutoCompleteClick(item) {
      var _this3 = this;

      var onChange = this.props.onChange;

      var initialData = this.state.default_value.slice(0, this.state.default_value.indexOf('@'));
      this.setState({
        default_value: initialData + '[~' + item.name.split(' ').join('_') + ']',
        autocomplete_items: []
      }, function () {
        _reactDom2.default.findDOMNode(_this3.refs.binary_text_box).getElementsByTagName('textarea')[0].value = _this3.state.default_value;
        _reactDom2.default.findDOMNode(_this3.refs.binary_text_box).getElementsByTagName('textarea')[1].value = _this3.state.default_value;
        _reactDom2.default.findDOMNode(_this3.refs.binary_text_box).getElementsByTagName('textarea')[0].focus();
        _reactDom2.default.findDOMNode(_this3.refs.binary_text_box).getElementsByTagName('textarea')[1].focus();

        if (onChange) {
          onChange(_this3.replaceAutoComplete(_this3.state.default_value));
        }
      });
    }
  }, {
    key: 'replaceAutoComplete',
    value: function replaceAutoComplete(value) {
      var autocomplete = this.props.autocomplete;

      var valueAutoComplete = value;
      if (autocomplete) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = autocomplete[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var item = _step2.value;

            valueAutoComplete = this.replaceAll('[~' + item.name.split(' ').join('_') + ']', valueAutoComplete, '[' + btoa(item.id) + '|' + item.name + ']');
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
      return valueAutoComplete;
    }
  }, {
    key: 'replaceAll',
    value: function replaceAll(search, target, replacement) {
      return target.split(search).join(replacement);
    }
  }, {
    key: 'checkEmpty',
    value: function checkEmpty(value) {
      return value === undefined || value === null || String(value).trim() === '';
    }
  }, {
    key: 'checkLimit',
    value: function checkLimit(value) {
      var limit = this.props.limit;

      return String(value).length < limit || String(value).length === limit;
    }
  }, {
    key: 'checkMinChars',
    value: function checkMinChars(value) {
      var minChars = this.props.minChars;

      return String(value).length > minChars;
    }
  }, {
    key: 'checkNumeric',
    value: function checkNumeric(value) {
      return !isNaN(parseFloat(value)) && isFinite(value);
    }
  }, {
    key: 'checEmail',
    value: function checEmail(value) {
      var regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regex.test(value);
    }
  }, {
    key: 'checkPhone',
    value: function checkPhone(value) {
      var regex = /^\d{10}$/;
      return regex.test(value);
    }
  }, {
    key: 'checkPassword',
    value: function checkPassword(value) {
      var checkLowerCase = /[a-z]/.test(value);
      var checkUpperCase = /[A-Z]/.test(value);
      var checkNumber = /\d/.test(value);
      return checkLowerCase && checkUpperCase && checkNumber;
    }
  }, {
    key: 'checkAtLeastOneAlphabet',
    value: function checkAtLeastOneAlphabet(value) {
      return value.trim().toLowerCase().match(/[a-z]/i) !== null;
    }
  }, {
    key: 'checkUserName',
    value: function checkUserName(value) {
      var regex = /^[a-zA-Z0-9]+$/;
      return regex.test(value);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          multiLine = _props3.multiLine,
          validationBool = _props3.validationBool,
          rte = _props3.rte,
          limit = _props3.limit,
          errorText = _props3.errorText,
          customClassName = _props3.customClassName,
          defaultValue = _props3.defaultValue,
          keyPress = _props3.keyPress;

      var classNameDisabled = this.props.disabled ? this.styles.disabled : '';
      var classNameExtra = customClassName ? customClassName : '';
      return _react2.default.createElement(
        'div',
        { ref: 'binary_text_box' },
        !rte && _react2.default.createElement(_textField2.default, _extends({}, this.props, {
          errorStyle: { top: '5px' },
          className: multiLine ? this.styles.binary_text_box + ' ' + classNameDisabled + ' ' + classNameExtra : this.styles.binary_input + ' ' + classNameDisabled + ' ' + classNameExtra,
          rows: multiLine ? 2 : 0,
          rowsMax: multiLine ? 5 : 1,
          onChange: this.onChange.bind(this),
          errorText: validationBool && this.state.errorText || errorText && errorText.length > 0,
          maxLength: limit
        })),
        rte && _react2.default.createElement(_reactTinymce2.default, {
          content: defaultValue,
          className: customClassName,
          id: 'binary_text_rte',
          config: {
            elementpath: false,
            body_class: 'no-margin',
            height: 600,
            menubar: false,
            resize: false,
            visual: false,
            plugins: ['noneditable textcolor lists'],
            toolbar: 'undo redo | bold italic underline | fontselect fontsizeselect | bullist numlist | alignleft aligncenter alignright | forecolor backcolor'
          },
          onChange: this.handleRTEChange.bind(this),
          onKeypress: keyPress ? this.handleRTEKeypress.bind(this) : ''
        }),
        rte && this.state.errorText !== '' && _react2.default.createElement(
          'div',
          { className: this.styles.rte_error },
          validationBool && this.state.errorText
        ),
        rte && this.props.disabled && _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.getCurrentRichData() } }),
        this.state.autocomplete_items.length > 0 && _react2.default.createElement(
          'div',
          { className: this.styles.autocomplete_container },
          this.state.autocomplete_items
        )
      );
    }
  }]);

  return BinaryTextBox;
}(_react.Component);

BinaryTextBox.propTypes = {
  id: _propTypes2.default.string,
  name: _propTypes2.default.string,
  multiLine: _propTypes2.default.bool,
  rte: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  emptyLabel: _propTypes2.default.string,
  minChars: _propTypes2.default.number,
  minCharsLabel: _propTypes2.default.string,
  limit: _propTypes2.default.number,
  floatingLabelText: _propTypes2.default.string,
  value: _propTypes2.default.string,
  defaultValue: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  errorText: _propTypes2.default.string,
  validationBool: _propTypes2.default.bool,
  validateAtLeastOneAlphabet: _propTypes2.default.bool,
  validateNumeric: _propTypes2.default.bool,
  validateEmail: _propTypes2.default.bool,
  validatePassword: _propTypes2.default.bool,
  validateUserName: _propTypes2.default.bool,
  validatePhone: _propTypes2.default.bool,
  autocomplete: _propTypes2.default.array, // {id: id, name: name}
  customClassName: _propTypes2.default.string,
  keyPress: _propTypes2.default.bool
};
BinaryTextBox.defaultProps = {
  id: 'binary_text_box_' + Math.random(),
  disabled: false,
  errorText: '',
  limit: 3000,
  minChars: 0,
  multiLine: true,
  rte: false,
  validateAtLeastOneAlphabet: false,
  validateNumeric: false,
  validateEmail: false,
  validatePassword: false,
  validateUserName: false,
  validatePhone: false,
  validationBool: true,
  keyPress: false
};
exports.default = BinaryTextBox;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryTextBox/BinaryTextBox.js
// module id = 1073
// module chunks = 1